import React, {FC} from 'react';

import {Colors, Text} from '@optimaxdev/design-system';
import {Icon, ArrowDown} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './detailToggle.scss';

export type PropsType = {
    isOpened: boolean;
    toggleOpen: () => void;
};

/**
 * Toggle button for showing/hiding details on TYP0
 */
export const DetailToggle: FC<PropsType> = ({isOpened, toggleOpen}) => {
    const isMobile = __BUILD_TYPE__ === 'mobile';

    return (
        <button
            className={classNames(s.button, {[s.mobile]: isMobile})}
            onClick={toggleOpen}
            type="button"
        >
            <Text
                color={isMobile ? Colors.mineShaft : Colors.limedSpruce}
                lineHeight={isMobile ? '150%' : '25px'}
                size={isMobile ? '14px' : '16px'}
                light
            >
                {isOpened ? 'Less details' : 'See details'}
            </Text>
            <Icon
                className={classNames({[s.iconOpened]: isOpened})}
                icon={ArrowDown}
                strokeWidth={3}
                width="8px"
            />
        </button>
    );
};
